import { render } from "./AppPaletteTemplateCard.vue?vue&type=template&id=8c6e6a64&scoped=true&ts=true"
import script from "./AppPaletteTemplateCard.vue?vue&type=script&lang=ts"
export * from "./AppPaletteTemplateCard.vue?vue&type=script&lang=ts"

import "./AppPaletteTemplateCard.vue?vue&type=style&index=0&id=8c6e6a64&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c6e6a64"]])

export default __exports__